import { clone } from "lodash-es";
export default {
  data() {
    return {
      saveMetaIgnoreFields: [],
      saveMeta: {
        saveProcess: false,
        originalForm: null,
        interval: null,
        trackFormChanges: "form"
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSaveMetaDisabled === true) next();
    return this.saveMetaUnsaveConfirm(to, from, next);
  },
  mounted() {
    this.saveMeta.interval = setInterval(() => {
      const form = this.form || this[this.$options.trackFormComparision];
      if (form && this.$apollo.loading == false) {
        this.saveMetaSetOriginalForm(form);
        clearInterval(this.saveMeta.interval);
        this.saveMeta.interval = null;
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.saveMeta.interval);
  },
  methods: {
    async saveMetaUnsaveConfirm(to, from, next) {
      const { originalForm, saveProcess } = this.saveMeta;

      const formWithoutIgnoredFields = clone(this.form);
      if (Array.isArray(this.saveMetaIgnoreFields)) {
        this.saveMetaIgnoreFields.forEach(
          k => delete formWithoutIgnoredFields[k]
        );
      }

      if (
        !originalForm ||
        saveProcess === true ||
        originalForm == JSON.stringify(formWithoutIgnoredFields)
      ) {
        if (next) next();
        return true;
      } else {
        const answer = await this.$root.$confirm();
        if (answer == true) {
          if (next) next();
          return true;
        } else {
          // User clicking go/forward changes the URL
          if (next) this.$router.forward();
          return false;
        }
      }
    },
    // compare JSON strings if user has done any real changes at all
    saveMetaSetOriginalForm(form) {
      clearInterval(this.saveMeta.interval);
      let formToBeBasedOnForComparision = 0;
      if (form) {
        formToBeBasedOnForComparision = clone(form);
      } else if (this.$options.trackFormComparision) {
        formToBeBasedOnForComparision = clone(
          this[this.$options.trackFormComparision]
        );
      }

      if (
        formToBeBasedOnForComparision != 0 &&
        Array.isArray(this.saveMetaIgnoreFields)
      ) {
        this.saveMetaIgnoreFields.forEach(
          k => delete formToBeBasedOnForComparision[k]
        );
      }

      this.saveMeta.originalForm = JSON.stringify(
        formToBeBasedOnForComparision
      );
    }
  }
};
